import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

export default function useGetRuralRoads() {
  const [geojson, setGeojson] = useState(null);
  const [roads, setRoads] = useState([]);

  useEffect(() => {
    authFetch(`${API_URL}emergency-layers/rural-roads`)
      .then(res => res.json())
      .then(data => {
        setGeojson(data);
        setRoads(data.features.map(f => ({
          id: f.properties.id,
          name: f.properties.name,
          color: f.properties.color
        })));
      })
      .catch(err => console.error('Error al cargar caminos rurales:', err));
  }, []);

  return { geojson, roads };
}
